import { render, staticRenderFns } from "./MiningModal.vue?vue&type=template&id=54ca1e14&"
import script from "./MiningModal.vue?vue&type=script&lang=js&"
export * from "./MiningModal.vue?vue&type=script&lang=js&"
import style0 from "./MiningModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports